export default {
    complete: {
        className: 'complete',
        codeName: 'COMPLETE',
        icon: {
            iconType: 'ok',
            className: 'completeIcon',
            iconTitle: 'Complete icon',
            iconDescr: 'check mark symbol',
        },
    },
    incomplete: {
        className: 'incomplete',
        codeName: 'INCOMPLETE',
        icon: {
            iconType: 'error',
            className: 'incompleteIcon',
            iconTitle: 'Incomplete',
            iconDescr: 'Exclamation mark',
        },
    },
    optional: {
        className: 'optional',
        codeName: 'OPTIONAL',
        icon: {
            iconType: 'add',
            className: 'optionalIcon',
            iconTitle: 'Optional icon',
            iconDescr: 'question mark symbol',
        },
    },
    disabled: {
        className: 'not-available',
        codeName: 'NOT_AVAILABLE',
    },
    cancelled: {
        className: 'incomplete',
        codeName: 'CANCELLED',
    },
} as const;
